import React, { useState, useEffect } from "react";
import { FileText, Globe, Calendar } from "lucide-react";
import { updateAboutInfo } from "../../apiCalls/user";

const AboutLab = ({ aboutData, labId, isEditing, setIsEditing }) => {
  const [profileData, setProfileData] = useState({
    establishedYear: "", labWebsite: "", labDesc: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit,   setIsSubmit]   = useState(false);

  useEffect(() => { if (aboutData) setProfileData((p) => ({ ...p, ...aboutData })); }, [aboutData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfileData((p) => ({ ...p, [name]: value }));
  };

  const handleSave = (e) => {
    e.preventDefault();
    setFormErrors({});
    setIsSubmit(true);
  };

  const handleClick = async () => {
    const { establishedYear, labWebsite, labDesc } = profileData;
    await updateAboutInfo({ establishedYear, labWebsite, labDesc }, labId);
    setIsEditing(false);
  };

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) handleClick();
  }, [formErrors]);

  return (
    <div className="form-card">
      <div className="form-card-header">
        <h5 className="form-card-title">
          <FileText size={15} /> About Lab
        </h5>
      </div>

      <div className="form-card-body">
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.875rem" }}>
          {/* Website */}
          <div className="field">
            <label className="field-label"><Globe size={13} /> Website</label>
            <input
              type="url"
              name="labWebsite"
              value={profileData.labWebsite || ""}
              onChange={handleInputChange}
              disabled={!isEditing}
              className="field-input"
              placeholder={isEditing ? "https://yourlab.com" : "—"}
            />
          </div>

          {/* Established Year */}
          <div className="field">
            <label className="field-label"><Calendar size={13} /> Established Year</label>
            <input
              type="number"
              name="establishedYear"
              value={profileData.establishedYear || ""}
              onChange={handleInputChange}
              disabled={!isEditing}
              className="field-input"
              placeholder={isEditing ? "e.g. 2010" : "—"}
              min={1900}
              max={new Date().getFullYear()}
            />
          </div>
        </div>

        {/* Description */}
        <div className="field">
          <label className="field-label"><FileText size={13} /> Description</label>
          <textarea
            name="labDesc"
            value={profileData.labDesc || ""}
            onChange={handleInputChange}
            disabled={!isEditing}
            rows={4}
            className="field-textarea"
            placeholder={isEditing ? "Describe your lab, specialisations, services…" : "—"}
          />
        </div>

        {isEditing && (
          <button className="app-btn app-btn--primary" onClick={handleSave} style={{ marginTop: "0.5rem" }}>
            <FileText size={14} /> Save About Info
          </button>
        )}
      </div>
    </div>
  );
};

export default AboutLab;
